import { AdditionalReferenceParentType } from './models/types'

export const ADDITIONAL_REFERENCE_KEY = 'additional-reference'

// eslint-disable-next-line import/prefer-default-export
export const additionalReferenceQueryKeys = {
  allByParams: (params: { parentId: number | null; parentType: AdditionalReferenceParentType }) => [ADDITIONAL_REFERENCE_KEY, params],
}
